import { getUIContext, apiAdn } from "./common";

export function createTraduction(props: { sjmoCode: string; resourceKey: string; title: string }) {
  const params = getUIContext({ sjmoCode: props.sjmoCode });
  return apiAdn.post(`/admin/common/traduction?${params}`, props);
}

export function createAllMissingTrad(lang: string) {
  const params = getUIContext({ sjmoCode: "ADMIN" });
  return apiAdn.post(`/admin/common/traduction/synchronise?${params}&lang=${lang}`);
}
export function createAllMissingMsg(lang: string) {
  const params = getUIContext({ sjmoCode: "ADMIN" });
  return apiAdn.post(`/admin/common/message/synchronise?${params}&lang=${lang}`);
}
